import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ title, value, subtitle, icon, trend, trendValue, color = "primary" }) => {
  const getColorClasses = () => {
    switch (color) {
      case 'success':
        return 'bg-success/10 text-success border-success/20';
      case 'warning':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'error':
        return 'bg-error/10 text-error border-error/20';
      case 'accent':
        return 'bg-accent/10 text-accent border-accent/20';
      default:
        return 'bg-primary/10 text-primary border-primary/20';
    }
  };

  const getTrendIcon = () => {
    if (trend === 'up') return 'TrendingUp';
    if (trend === 'down') return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (trend === 'up') return 'text-success';
    if (trend === 'down') return 'text-error';
    return 'text-muted-foreground';
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 hover:shadow-subtle transition-all duration-200">
      <div className="flex items-start justify-between gap-2">
        <div className="space-y-1 min-w-0">
          <p className="text-xs md:text-sm font-medium text-muted-foreground truncate">{title}</p>
          <p className="text-xl md:text-2xl font-bold text-foreground tracking-tight">{value}</p>
        </div>
        <div className={`p-2.5 md:p-3 rounded-xl flex-shrink-0 ${getColorClasses()}`}>
          <Icon name={icon} size={20} className="md:w-6 md:h-6" />
        </div>
      </div>
      {(subtitle || (trend && trendValue)) && (
        <div className="flex items-center justify-between mt-3 pt-2 border-t border-border/50 text-[10px] md:text-xs">
          <span className="text-muted-foreground truncate max-w-[70%]">{subtitle}</span>
          {trend && trendValue && (
            <div className={`flex items-center space-x-0.5 ${getTrendColor()} shrink-0`}>
              <Icon name={getTrendIcon()} size={12} />
              <span className="font-semibold">{trendValue}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default KPICard;